import { useContext, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { updateUserDetails } from '../../../api/Optimise';
import { AppContext } from '../../../context/AppContext';
import Toggle from '../../Toggle';

import InformationPanel from './InformationPanel';

const OnOffSettings = ({ loadUser, setShowError }) => {
  const theme = useTheme();
  const { userDetails, setUserDetails, userSub } = useContext(AppContext);
  const [isOptimiseOff, setIsOptimiseOff] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (!!userDetails) {
      // simulation_mode is the key that the backend uses to determine whether optimise is on or off. If simulation_mode is true, then optimise is off.
      setIsOptimiseOff(userDetails?.simulation_mode);
      setIsLoading(false);
    }
  }, [userDetails]);

  const handleSwitchChange = async (newState) => {
    setIsSaving(true);
    updateUserDetails(
      {
        battery_soc_lower_limit: userDetails.battery_details.soc_lower_limit,
        battery_soc_upper_limit: 100,
        simulation_mode: !newState,
      },
      userSub
    )
      .then(() => {
        setIsOptimiseOff(!newState);
        setUserDetails((prev) => ({
          ...(prev ?? {}),
          simulation_mode: !newState,
        }));
      })
      .catch((e) => {
        console.error(e);
        setShowError(true);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  const titleText = `${theme.language.appName} is ${isOptimiseOff ? 'OFF' : 'ON'}`;

  const isOptimiseDisabledText = isOptimiseOff ? (
    <>
      {theme.language.appName} is currently <b>OFF</b>. You can turn <b>ON</b> {theme.language.appName} using the button
      below - this will allow {theme.language.appName} to control your battery. We are not able to show your battery
      status or any savings while {theme.language.appName} is <b>OFF</b>.
    </>
  ) : (
    <>
      {theme.language.appName} is currently <b>ON</b>. You can turn <b>OFF</b> {theme.language.appName} using the button
      below - this will stop {theme.language.appName} controlling your battery. We will not be able to show your battery
      status or any savings while {theme.language.appName} is <b>OFF</b>.
    </>
  );

  return (
    <InformationPanel title={titleText}>
      <li>
        {isOptimiseDisabledText}
        <Toggle
          switchOn={!isOptimiseOff}
          isLoading={isLoading}
          isSaving={isSaving}
          handleSwitchChange={handleSwitchChange}
        />
      </li>
    </InformationPanel>
  );
};

export default OnOffSettings;
